export default function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/d3-format/src/formatNumerals.js
// module id = ../../../../d3-format/src/formatNumerals.js
// module chunks = vendor